module.exports = __webpack_public_path__ + "assets/img/intr.fa7cb70b.jpg";